/**
 * Module Constants
 */
export const STORE_NAME = 'core/edit-navigation';
